const billTypes = {
    BILL_GET_LIST_ACTION:  "BILL_GET_LIST_ACTION",
    BILL_UPDATE_ACTION: "BILL_UPDATE_ACTION",
    BILL_GET_DETAIL_ACTION: "BILL_GET_DETAIL_ACTION",
    BILL_GET_LIST_SUCCESS:  "BILL_GET_LIST_SUCCESS",
    BILL_UPDATE_SUCCESS: "BILL_UPDATE_SUCCESS",
    BILL_GET_DETAIL_SUCCESS: "BILL_GET_DETAIL_SUCCESS",
    BILL_GET_LIST_FAILED:  "BILL_GET_LIST_FAILED",
    BILL_UPDATE_FAILED: "BILL_UPDATE_FAILED",
    BILL_GET_DETAIL_FAILED: "BILL_GET_DETAIL_FAILED",
}

export default billTypes;